var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandable = function SvgExpandable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#expandable_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M1.969 12.963h5.25a1.32 1.32 0 0 1 1.318 1.318v5.25A1.32 1.32 0 0 1 7.22 20.85h-5.25A1.32 1.32 0 0 1 .65 19.531v-5.25a1.32 1.32 0 0 1 1.319-1.319"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.3,
    d: "M1.969 12.963h5.25a1.32 1.32 0 0 1 1.318 1.318v5.25A1.32 1.32 0 0 1 7.22 20.85h-5.25A1.32 1.32 0 0 1 .65 19.531v-5.25a1.32 1.32 0 0 1 1.319-1.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.3,
    d: "M1.969 12.963h5.25a1.32 1.32 0 0 1 1.318 1.318v5.25A1.32 1.32 0 0 1 7.22 20.85h-5.25A1.32 1.32 0 0 1 .65 19.531v-5.25a1.32 1.32 0 0 1 1.319-1.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M19.031.5H1.97A1.975 1.975 0 0 0 0 2.469v9.187A3.24 3.24 0 0 1 1.969 11h5.25a3.28 3.28 0 0 1 3.281 3.281v5.25c0 .742-.243 1.424-.656 1.969h9.187A1.975 1.975 0 0 0 21 19.531V2.47A1.975 1.975 0 0 0 19.031.5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#expandable_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.196 4.832-.527-.527a.373.373 0 0 0-.527 0L11.927 8.52a.373.373 0 0 0 0 .527l.527.527a.373.373 0 0 0 .527 0l4.215-4.215a.373.373 0 0 0 0-.527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3 6.39.649-2.595a.237.237 0 0 0-.287-.287l-2.595.648a.237.237 0 0 0-.11.397L16.903 6.5c.13.13.353.069.397-.11"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expandable_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h21v21H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "expandable_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.09 2.469h8.94v8.94h-8.94z"
  })))));
};
export default SvgExpandable;